/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowphototop3Inputs */

const en_aiflowphototop3 = /** @type {(inputs: Aiflowphototop3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top`)
};

const de_aiflowphototop3 = /** @type {(inputs: Aiflowphototop3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oben`)
};

/**
* | output |
* | --- |
* | "Top" |
*
* @param {Aiflowphototop3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowphototop3 = /** @type {((inputs?: Aiflowphototop3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowphototop3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowphototop3(inputs)
	return de_aiflowphototop3(inputs)
});
export { aiflowphototop3 as "aiFlowPhotoTop" }